import moment from 'moment'
import domtoimage from 'dom-to-image-more'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import downloadBase64 from '~/util/base64'
import {
    money,
    phoneNumber,
    slugify,
    yesno,
    titlelize,
    titlelizeList,
    stat,
    summarizeList,
    toUpperCaseList,
    toUpperList,
    pluralize,
    name,
    toQuerystring
} from '~/util/string'

export default {
    beforeRouteLeave (to, from, next) {
        this.$root.$emit('bv::hide::tooltip')
        if (typeof window !== 'undefined' && window.document) {
            Array.from(window.document.querySelectorAll('.modal.show'))
                .map(el => el.id)
                .forEach((id) => {
                    this.$root.$emit('bv::hide::modal', id)
                })
        }
        next()
    },
    computed: {
        ...mapGetters([
            'hostUrl',
            'effectiveHostUrl',
            'isServer',
            'lightTheme',
            'darkTheme',
            'edge',
            'user',
            'fullserve',
            'fullservePlus',
            'selfserve',
            'group',
            'asGroup',
            'inGroup',
            'groupPaying',
            'groupIchra',
            'groupFinancialAdvisor',
            'groupName',
            'fromDCI',
            'fromDPC',
            'isSize',
            's3Base',
            'isClient',
            'isHr',
            'isAgent',
            'isAdmin',
            'isSu',
            'canClient',
            'canHr',
            'canAgent',
            'canAdmin',
            'canSu',
            'isAgentMode',
        ]),
        currentLayout () {
            // tacky
            return _.find(this.$root.$children, vm => vm?.$refs?.body)
        },
        header () {
            return this?.currentLayout?.$refs?.header
        },
        body () {
            return this?.currentLayout?.$refs?.body
        },
        footer () {
            return this?.currentLayout?.$refs?.footer
        }
    },
    data () {
        return { uuid: uuidv4() }
    },
    methods: {
        noop () {},
        setGlobal (key, value) {
            if (typeof window !== 'undefined') {
                window[key] = value
            } else {
                global[key] = value
            }
        },
        setBusy () {
            this.$store.dispatch('busy')
        },
        setIdle () {
            this.$store.dispatch('idle')
        },
        trace (...args) {
            console.trace(...args)
            return args[0]
        },
        inspect (...args) {
            /* eslint-disable */
            console.trace(...args)
            debugger
            return args[0]
        },
        dateFormat(date, format) {
            return moment(date).format(format)
        },
        focus(selector) {
            const el = this.$el.querySelector(selector)
            if (el) {
                setTimeout(() => el.focus(), 0)
            }
        },
        toName: name,
        stat,
        yesno,
        money,
        phoneNumber,
        pluralize,
        titlelize,
        titlelizeList,
        summarizeList,
        toUpperList,
        toUpperCaseList,
        toQuerystring,
        downloadBase64,
        timeout (fn, ms) {
            return setTimeout(fn, ms)
        },
        replaceTrailingSlash(u) {
            return (u || '').replace(/\/$/, '')
        },        
        sentryCaptureMessage (message, options = {}) {
            options = options || {}
            const level = options.level || 'warning'
            const contexts = {
                ...(options.contexts || {})
            }
            contexts.extra = {
                ...(contexts.extra || {}),
                client: this.$store.getters?.client?.id,
                user: this.$store?.getters?.user?.id,
                env: process.env.NODE_ENV,
            }
            const tags = options.tags || {}
            if (this.$sentry) {
                if (options.screenshot) {
                    setTimeout(async () => {
                        const shot = await this.captureShot(message)
                        return this.$sentry.captureMessage(message, { level, contexts: { ...contexts, shot }, tags })
                    }, 300)
                } else {
                    return this.$sentry.captureMessage(message, { level, contexts, tags })
                }
            }
        },
        sentryBreadCrumb (message, options = {}) {
            const category = options.category
            const level = options.level || 'info'
            const data = options.data || {}
            if (this.$sentry) {
                this.$sentry.addBreadcrumb({
                    message,
                    category,
                    level,
                    data: {
                        ...data
                    },
                })
            }
        },
        async captureShot (message = 'no-message') {
            const blob = await domtoimage.toBlob(document.body)
            const file = new File([blob], `${slugify(message)}`.slice(0, 60) + '.png')
            const form = new FormData()
            form.append('files', file)
            const arr = await this.$api.uploadSentryShots(form)
            return arr[0]
        },
        async detectZipFromGeolocation () {
            // Ask user for permission and resolve current position
            if (typeof window === 'undefined' || !('geolocation' in navigator)) {
                console.warn('Geolocation not supported')
                return null
            }
            let position
            try {
                position = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject, {
                        enableHighAccuracy: true,
                        timeout: 10000,
                        maximumAge: 0
                    })
                })
                console.log('Geolocation position obtained', position)
            } catch (e) {
                console.warn('User denied geolocation or error obtaining position', e)
                return null
            }

            const { latitude: lat, longitude: lon } = position.coords
            let zip = null

            // Try BigDataCloud first
            try {
                const r = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`)
                if (r.ok) {
                    const data = await r.json()
                    console.log('BigDataCloud reverse geocode response', data)
                    zip = data.postcode || data.postalCode || null
                }
            } catch (e) {
                console.warn('BigDataCloud reverse geocode failed', e)
            }

            // Fallback to OpenStreetMap Nominatim
            if (!zip) {
                try {
                    const r2 = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`)
                    if (r2.ok) {
                        const data2 = await r2.json()
                        console.log('Nominatim reverse geocode response', data2)
                        zip = data2?.address?.postcode || null
                    }
                } catch (e) {
                    console.warn('Nominatim reverse geocode failed', e)
                }
            }

            if (zip) {
                this.$store.commit('field', { field: 'zip_code', value: zip })
                const resp = await this.$api.getCountiesForZip(zip)
                if (resp) {
                    let counties = resp.counties
                    if (counties?.length) {
                        this.$store.commit('field', { field: 'fips', value: _.get(counties, '0.fips') })
                        this.$store.commit('field', { field: 'state', value: _.get(counties, '0.state') })
                        this.$store.commit('field', { field: 'county', value: _.get(counties, '0.name') })
                    }
                }
            } else {
                console.warn('Could not determine ZIP code from coordinates')
            }
            return zip
        }
    }
}
